import {connect}  from 'react-redux';

function Message(props) {

if (props.showMessage === false) {
	return null;
}

return (
		<div className="messageWrapper">
			<div className="message">
				{props.message}
			</div>
		</div>
	);
}

const mapStateToProps = (state) =>  {
	return {message: state.message, showMessage: state.showMessage};
};

export default connect(mapStateToProps)(Message);